'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "selected", "multiselect", "onSelect"];
import { useEffect } from 'react';
import { CommandGroup } from "../_shadcn-native-components/command";
import { cn } from "../utils";
import { useDropdownContext } from "./context";
import { jsx as _jsx } from "react/jsx-runtime";
export var DropdownBaseList = function DropdownBaseList(_ref) {
  var className = _ref.className,
    selected = _ref.selected,
    multiselect = _ref.multiselect,
    onSelect = _ref.onSelect,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useDropdownContext = useDropdownContext(),
    setValues = _useDropdownContext.setValues;

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (!selected) return;

    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (typeof selected === 'string' || typeof selected === 'number') setValues([selected]);
    // biome-ignore lint/style/useBlockStatements: single-line early return
    else setValues(selected);
  }, [selected]);
  return /*#__PURE__*/_jsx(CommandGroup, _objectSpread({
    className: cn('tw-max-h-24 tw-overflow-y-auto', className)
  }, props));
};